<div class="core-engine-form-container">
  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>
  
  <div class="form-heading">
    <h1>{{ id > 0 ? 'Update' : 'New' }} Audio QR Code</h1>
    <div class="options">
      <button *ngIf="id > 0" (click)="save(true)" >Save Copy</button>
      <button (click)="save(false)" >{{ id > 0 ? 'Update' : 'Save' }}</button>
      <button (click)="navigateUp()">Cancel</button>    
    </div>
  </div>
  <app-visual-json-editor
    [setJson]="json"
    [setRestrictedKeyValuePairs]="{}"
    [(objectName)]="objectName"
    (outputJson)="outputJson = $event"
  >

  </app-visual-json-editor>
</div>
